import { onBeforeUnmount, ref, watch } from 'vue'

export const wizardDraft = fallback => {
  const name = ref(null)
  const follow = source => {
    watch(source, value => (name.value = value || fallback), { immediate: true })
    onBeforeUnmount(() => (name.value = null))
  }
  return { name, follow }
}

export const tierDraft = wizardDraft('New tier')
export const methodDraft = wizardDraft('New method')
